import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

const GOOGLE_PLAY_URL = 'https://play.google.com/store/apps/details?id=com.lanerunner.app';

const ACCENT = '#22c55e';
const ACCENT_SOFT = 'rgba(34, 197, 94, 0.12)';
const GRADIENT_FROM = '#E7FBEE';
const BORDER_TINT = 'rgba(34, 197, 94, 0.35)';

const HeroRotator: React.FC = () => {
  return (
    <div className="relative w-full">
      <div
        className="relative w-full text-center rounded-2xl px-8 py-10 sm:px-12 sm:py-14 shadow-xl border overflow-hidden"
        style={{
          background: `linear-gradient(to bottom, ${GRADIENT_FROM}, #ffffff)`,
          borderColor: BORDER_TINT,
          boxShadow: `0 20px 40px -20px ${ACCENT_SOFT}`,
        }}
      >
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl mb-4 sm:mb-6 leading-tight">
          <span className="text-gray-950">The Modern Freight Load Board.</span>
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto mb-6 leading-relaxed">
          Loads that are real, trucks that are ready, and a board that loads in seconds instead of
          fighting you. Post your freight or find your next load and see why brokers and carriers are
          switching. Your next lane is already here.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6">
          <Button
            asChild
            size="lg"
            className="w-full sm:w-auto text-white font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full"
            style={{ backgroundColor: ACCENT, color: '#ffffff' }}
          >
            <Link to="/brokers">
              Brokers: Post Freight
              <ArrowRight className="ml-2 h-4 sm:h-5 w-4 sm:w-5" />
            </Link>
          </Button>
          <Button
            asChild
            size="lg"
            variant="outline"
            className="w-full sm:w-auto border-2 font-semibold px-6 sm:px-8 py-5 sm:py-6 text-base sm:text-lg rounded-full bg-transparent"
            style={{ borderColor: ACCENT, color: ACCENT }}
          >
            <Link to="/carriers">Carriers: Find Loads</Link>
          </Button>
        </div>

        {/* Google Play badge */}
        <div className="flex items-center justify-center">
          <a
            href={GOOGLE_PLAY_URL}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Get LaneRunner on Google Play"
            className="inline-flex items-center hover:opacity-90 transition-opacity"
          >
            <img
              src="/images/google-play-badge-light.png"
              alt="Get LaneRunner on Google Play"
              width={708}
              height={230}
              className="h-[46px] w-auto max-w-[170px] object-contain sm:h-[52px] sm:max-w-[180px]"
              loading="lazy"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

export default HeroRotator;
